import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#6366f1', '#14b8a6', '#f59e0b', '#ef4444', '#22c55e', '#0ea5e9', '#a855f7', '#f97316', '#10b981', '#eab308'];

const TopDestinationsBar = ({ data = [], title = 'Top Destinations' }) => {
  const chartData = Array.isArray(data)
    ? data.map((item) => {
        const fullLabel = item?.label || 'Unknown';
        return {
          ...item,
          fullLabel,
          label: fullLabel.length > 22 ? `${fullLabel.slice(0, 22)}...` : fullLabel,
          value: Number(item?.value || 0)
        };
      })
    : [];

  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <span className="text-xs text-gray-500">Top {chartData.length}</span>
      </div>
      {chartData?.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
          <div className="h-56">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="label"
                  innerRadius={50}
                  outerRadius={80}
                  paddingAngle={2}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => [value, 'Leads']} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="space-y-2">
            {chartData.map((item, index) => (
              <div key={`${item.label}-${index}`} className="flex items-center justify-between text-xs text-gray-700">
                <div className="flex items-center gap-2">
                  <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }}></span>
                  <span title={item.fullLabel} className="font-medium text-gray-800">{item.label}</span>
                </div>
                <span className="text-gray-900 font-semibold">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="h-40 flex items-center justify-center text-sm text-gray-400">No data available</div>
      )}
    </div>
  );
};

export default TopDestinationsBar;
